import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@dealer-center/core-components";

export function DealerEntityAccordionItem({
  accountEntity
}: {
  accountEntity: string;
}) {
  return (
    <Accordion>
      <AccordionSummary>Dealer</AccordionSummary>
      <AccordionDetails>
        <pre>{accountEntity}</pre>
      </AccordionDetails>
    </Accordion>
  );
}
